import React, { useEffect, useState } from 'react';
import Header from "../../components/Header/Header";
import { useDispatch, useSelector } from "react-redux";
import { copyBookingSagaAction, getWeekBookingSagaAction } from "../../redux/sagaActions";
import BookingForm from "../../components/BookingForm/BookingForm";
import BookingHeader from "../../components/PagesHeaders/BookingHeader/BookingHeader";
import WeekBooking from "../../components/WeekBooking/WeekBooking";
import CalendarForm from "../../components/CalendarForm/CalendarForm";
import { calendarAction } from "../../redux/rootReducer";
import { CALENDAR_INITIAL } from "../../redux/initialStateConstant";
import BookingNotificationForm from "../../components/BookingNotificationForm/BookingNotificationForm";
import BookingUsersForm from "../../components/BookingUsersForm/BookingUsersForm";
import AvailableSubscriptionsForm from "../../components/AvailableSubscriptionsForm/AvailableSubscriptionsForm";
import AddSubscriptionForm from "../../components/AddSubscriptionForm/AddSubscriptionForm";
import OneTimeWorkoutForm from "../../components/OneTimeWorkoutForm/OneTimeWorkoutForm";

const Booking = () => {
    const dispatch = useDispatch();

    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const bookingForm = useSelector(state => state.bookingForm);
    const booking_users_form = useSelector(state => state.booking_users_form);
    const calendar = useSelector(state => state.calendar);
    const bookingNotificationForm = useSelector(state => state.bookingNotificationForm);
    const available_subscriptions_form = useSelector(state => state.available_subscriptions_form);
    const oneTimeWorkoutForm = useSelector(state => state.oneTimeWorkoutForm);
    const addSubscriptionForm = useSelector(state => state.addSubscriptionForm);

    const [copyBooking, setCopyBooking] = useState('');

    useEffect(() => {

        if (!currentEstablishment) return;

        dispatch(getWeekBookingSagaAction({
            establishment: currentEstablishment
        }));
    }, [currentEstablishment]);

    return (
        <>
            <Header component={ <BookingHeader/> }/>
            { bookingForm.open ? <BookingForm setCopyBooking={ setCopyBooking }/> : false }
            { booking_users_form.open && <BookingUsersForm/> }
            { bookingNotificationForm.open ? <BookingNotificationForm/> : false }
            { available_subscriptions_form.open && <AvailableSubscriptionsForm/> }
            { addSubscriptionForm.open && <AddSubscriptionForm/> }
            { oneTimeWorkoutForm.open && <OneTimeWorkoutForm/> }
            {
                calendar.type === 'booking_copy' &&
                <CalendarForm
                    title={ 'Копирование записи' }
                    close={ () => {
                        setCopyBooking('');
                        dispatch(calendarAction(CALENDAR_INITIAL));
                    } }
                    submit={ daysArr => {
                        dispatch(copyBookingSagaAction({
                            booking_id: copyBooking,
                            copy_days: JSON.stringify(daysArr)
                        }));
                    } }
                />
            }
            <WeekBooking/>
        </>
    );
};

export default Booking;